// /enterprise — Bumpups for organizations; sales conversations go through the contact form.
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChartLine, faPhotoFilm, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import CtaBand from '../site/CtaBand';
import Seo from '../site/Seo';
import { SALES_FORM_URL } from '../site/siteLinks';
import './enterprise.css';

const VALUES = [
  {
    icon: faPhotoFilm,
    title: 'Every video source',
    text: 'Bring together YouTube and local video from across your organization in one place.',
  },
  {
    icon: faChartLine,
    title: 'Strategic insights',
    text: 'Transform raw video into summaries, timestamps, analyses and answers your teams can act on.',
  },
  {
    icon: faShieldHalved,
    title: 'Secure and scalable',
    text: 'Process video at the scale your enterprise needs, with the security it expects.',
  },
];

const ContactSales = () => (
  <a href={SALES_FORM_URL} target="_blank" rel="noopener noreferrer" className="mk-btn mk-btn--primary">
    Contact Sales Team <FontAwesomeIcon icon={faArrowRight} className="mk-btn-arrow" />
  </a>
);

const EnterpriseAPI = () => (
  <>
    <Seo
      title="Bumpups for enterprise teams | Bumpups.com"
      description="Elevate your enterprise's video processing with Bumpups' AI-powered platform. Seamlessly integrate diverse video sources, transform raw content into strategic insights, and scale securely."
    />

    <section className="ent-hero mk-hero-bg">
      <div className="mk-container mk-section-head">
        <p className="mk-eyebrow">Bumpups Enterprise</p>
        <h1 className="mk-h1">
          <span className="mk-accent">Enterprise</span> video intelligence
        </h1>
        <p className="mk-lead">
          Empower your organization with AI that transforms raw video into strategic insights, seamlessly
          integrating into your enterprise for secure, scalable processing.
        </p>
        <div className="mk-actions">
          <ContactSales />
          <a href="mailto:contact@bumpups.com" className="mk-btn">Email us</a>
        </div>
      </div>
    </section>

    <section className="mk-section mk-section--tight">
      <div className="mk-container">
        <div className="mk-grid mk-grid--3">
          {VALUES.map(v => (
            <div key={v.title} className="mk-card ent-value">
              <span className="mk-icon"><FontAwesomeIcon icon={v.icon} /></span>
              <h2 className="mk-h3">{v.title}</h2>
              <p className="mk-text">{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <CtaBand title="Talk to our team" text="Tell us about your videos and we’ll put together a plan for your organization.">
      <ContactSales />
    </CtaBand>
  </>
);

export default EnterpriseAPI;
